export enum EntityType {
  None = 0,
  Holding = 1,
  GpLevel = 2
}
